import '../../assets/index41.css';var w = Object.defineProperty, B = Object.defineProperties;
var P = Object.getOwnPropertyDescriptors;
var l = Object.getOwnPropertySymbols;
var f = Object.prototype.hasOwnProperty, _ = Object.prototype.propertyIsEnumerable;
var u = (e, o, s) => o in e ? w(e, o, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[o] = s, m = (e, o) => {
  for (var s in o || (o = {}))
    f.call(o, s) && u(e, s, o[s]);
  if (l)
    for (var s of l(o))
      _.call(o, s) && u(e, s, o[s]);
  return e;
}, k = (e, o) => B(e, P(o));
var i = (e, o) => {
  var s = {};
  for (var t in e)
    f.call(e, t) && o.indexOf(t) < 0 && (s[t] = e[t]);
  if (e != null && l)
    for (var t of l(e))
      o.indexOf(t) < 0 && _.call(e, t) && (s[t] = e[t]);
  return s;
};
import { jsx as v } from "react/jsx-runtime";
import { forwardRef as $ } from "react";
import { r as n } from "../../rem-CMQJ_ZTp.js";
import { e as j } from "../../get-size-Bc1Pz5yf.js";
import { c as H } from "../../create-vars-resolver-Bzbn9G-G.js";
import { f as Q, u as T, B as V } from "../../factory-ueRxoNOV.js";
import { u as Z } from "../../use-styles-DToiHEa6.js";
var S = { root: "m_18320242", "skeleton-fade": "m_299c329c" };
const q = {
  visible: !0,
  animate: !0
}, z = H(
  (e, { width: o, height: s, radius: t, circle: r }) => ({
    root: {
      "--skeleton-height": n(s),
      "--skeleton-width": r ? n(s) : n(o),
      "--skeleton-radius": r ? "1000px" : t === void 0 ? void 0 : j(t)
    }
  })
), c = Q((e, o) => {
  const s = T("Skeleton", q, e), p = s, {
    classNames: t,
    className: r,
    style: d,
    styles: a,
    unstyled: y,
    vars: b,
    width: F,
    height: G,
    circle: I,
    visible: h,
    radius: J,
    animate: N,
    mod: g
  } = p, x = i(p, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "width",
    "height",
    "circle",
    "visible",
    "radius",
    "animate",
    "mod"
  ]), R = Z({
    name: "Skeleton",
    classes: S,
    props: s,
    className: r,
    style: d,
    classNames: t,
    styles: a,
    unstyled: y,
    vars: b,
    varsResolver: z
  });
  return /* @__PURE__ */ v(V, m(k(m({ ref: o }, R("root")), { mod: [{ visible: h, animate: N }, g] }), x));
});
c.classes = S;
c.displayName = "@mantine/core/Skeleton";
const A = "Skeleton-module__root___ZcTH2", C = "Skeleton-module__visible___7fQg0", D = {
  root: A,
  visible: C
}, E = $((d, r) => {
  var a = d, {
    "data-plum-id": e,
    className: o,
    visible: s = !0
  } = a, t = i(a, [
    "data-plum-id",
    "className",
    "visible"
  ]);
  return /* @__PURE__ */ v(
    c,
    m({
      ref: r,
      visible: s,
      classNames: D,
      className: o,
      "data-plum-id": e
    }, t)
  );
});
E.displayName = "Skeleton";
export {
  E as Skeleton
};
